import React from 'react'
import Featurecard from './Featurecard'
import './components.css'

const Featureslider = ({ features }) => {
    // console.log(features)

    return (
        <div>
            <div className='flex-container'>
                {
                    features.map(feature => (
                        <div className='card'>
                            <Featurecard image={feature.icon_usp_list_homepage} title={feature.title_usp_list_homepage} />
                        </div>
                    ))
                }
            </div>
        </div >
    )
}

export default Featureslider